import { useDispatch, useSelector } from 'react-redux';

// selectors
import * as tradeInsSelectors from '@makemydeal/dr-dash-store/selectors/tradeIns';
import * as tradeInsActionCreators from '@makemydeal/dr-dash-store/actions/tradeInsActionCreators';
import { useSingleTradeInFormProvider } from '../MultiTradeIn/TradeInFormProvider';

// libraries
import { kebabCase } from '@makemydeal/dr-common-utils';

// constants
import { ENGINE, ZERO_WIDTH_SPACE } from '../../../constants';

// components
import { TextInput } from '@makemydeal/dr-shared-components/text-input';
import { Typography } from '@interstate/components/Typography';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

// styling
import { DetailContainer } from '../trade.style';

interface EngineFieldProps {
    hasTradeIn: boolean;
    isManualFormOpen: boolean;
    disabled?: boolean;
}

export const EngineField: React.FC<EngineFieldProps> = ({ hasTradeIn, isManualFormOpen, disabled }) => {
    const dispatch = useDispatch();
    const { tradeInIndex } = useSingleTradeInFormProvider();
    const engine = useSelector(tradeInsSelectors.getEngine(tradeInIndex));

    const onChange = (event: any) => {
        dispatch(tradeInsActionCreators.updateTradeInEngine(event.target.value, tradeInIndex));
    };

    return (
        <>
            {isManualFormOpen ? (
                <TextInput
                    label={ENGINE}
                    data-testid={kebabCase(ENGINE)}
                    name={kebabCase(ENGINE)}
                    onChange={onChange}
                    value={engine}
                    disabled={disabled}
                    size="sm"
                    selectOnFocusSelector={featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap}
                />
            ) : (
                <>
                    {hasTradeIn && (
                        <DetailContainer>
                            <Typography variant="label-md" color="sem.color.on-surface.muted" sx={{ marginBottom: '8px' }}>
                                {ENGINE}
                            </Typography>
                            <Typography variant="body-md" tag="span" data-testid="trade-engine-value-label">
                                {engine || ZERO_WIDTH_SPACE}
                            </Typography>
                        </DetailContainer>
                    )}
                </>
            )}
        </>
    );
};
